import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Componente SEO para gestionar meta tags dinámicos y Schema Markup
 * @param {string} title Título de la página (Max 60 chars recomendado)
 * @param {string} description Descripción (150-160 chars)
 * @param {string} canonicalUrl URL canónica para evitar contenido duplicado
 * @param {object} schema JSON de Schema.org a inyectar
 * @param {boolean} noindex Pide a los buscadores no indexar la página
 * @param {React.ReactNode} children Tags extra (ej. otro JSON-LD). TASK-153: antes se ignoraban.
 */
const SEOMeta = ({
    title,
    description,
    canonicalUrl,
    schema,
    ogImage,
    noindex = false,
    children
}) => {
    const defaultOgImage = "https://www.uturno.com/og-image-premium.png"; // Ruta final en producción
    const currentOgImage = ogImage || defaultOgImage;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {noindex && <meta name="robots" content="noindex, follow" />}

            {/* Canonical Link */}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="uTurno" />
            <meta property="og:locale" content="es_AR" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={currentOgImage} />
            {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={currentOgImage} />

            {/* Structured Data (Schema.org) */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}

            {children}
        </Helmet>
    );
};

export default SEOMeta;
